<template>
  <PageHeader />
  <BaseCard>
    <template v-if="data?.data">
      <div class="flex justify-end">
        <button
          type="button"
          class="relative inline-flex cursor-pointer items-center rounded-lg border border-background bg-primary px-3 py-1 text-sm font-medium text-primary-fg hover:bg-primary/70 focus:z-10 focus:outline-none"
          @click="onAcceptImport"
        >
          Finish Import
        </button>
      </div>
      <ProductImportTable :rows="data?.data.rows" />
    </template>
  </BaseCard>
</template>

<script setup lang="ts">
const props = defineProps<{
  importId: string
}>()

const importId = toRef(props, "importId")

const { data } = useImportJob(importId)

const isSubmitting = ref(false)
const onAcceptImport = async () => {
  isSubmitting.value = true
  try {
    await acceptImport(props.importId)
  } catch (error) {
    logError(error)
    toast.error("Failed to accept import")
  } finally {
    isSubmitting.value = false
  }
}
</script>
